<template>
  <div class="rightsidebar">
    <ul class="quantitywidget">
      <star star-style="iconstar2"
            :is-select="starflag"
            :count="star"
            @changecount="changeStar"
            :showzero="false"
            :menu-id="this.$route.query.columnId"
            :business-id="this.$route.query.id"
            v-show="stardisplay"
            :title="title"
            :image="image"
            :url="url"/>
      <commnet v-show="commentShow" comment-style="iconcomment1"
               :count="commentCount"
               :comment-gotop="commentGotop"/>
      <collect collect-style="iconcollect2"
            :is-select="collectflag"
            :count="collect"
            @changecount="changeCollect"
            :showzero="false"
            :menu-id="this.$route.query.columnId"
            :business-id="this.$route.query.id"
            :title="title"
            :image="image"
            :url="url"/>
      <icon-share share-style="iconshare1" :count="share"></icon-share>
      <li class="nostyle">分享</li>
      <share :config="shareconfig"></share>
    </ul>
  </div>
</template>

<script>
import Star from '@/components/amount/star'
import Collect from '@/components/amount/collect'
import Commnet from '@/components/amount/comment'
import iconShare from '@/components/amount/iconshare'
import { setAmount, getAmount } from '@/api/datavolume/index'
export default {
  name: 'index',
  props: ['commentCount', 'commentGotop', 'commentShow', 'stardisplay', 'title', 'image', 'url'],
  components: {
    Star,
    Collect,
    Commnet,
    iconShare
  },
  data () {
    return {
      shareconfig: {
        url: location.href + '&share=1',
        sites: ['weibo', 'qzone', 'wechat'],
        wechatQrcodeTitle: '微信扫一扫：分享',
        wechatQrcodeHelper: '<p>扫一扫</p><p>二维码便可将本文分享至朋友圈。</p>'
      },
      star: 0,
      collect: 0,
      share: 0,
      pv: 0,
      // comment: 0,
      starflag: false,
      collectflag: false,
      param: {
        'menuId': this.$route.query.columnId,
        'businessId': this.$route.query.id,
        'webUserId': this.$cookie.get('wlymobilephone')
      }
    }
  },
  mounted () {
    // 分享量
    if (this.$route.query.share !== undefined) {
      this.setamount('share')
    }
    this.getamount()
  },
  methods: {
    changeStar (val) {
      this.star = val.count
      this.starflag = val.isSelect
    },
    changeCollect (val) {
      this.collect = val.count
      this.collectflag = val.isSelect
    },
    /* 滑动到评论模块 */
    Gocomment () {
      let top = this.commentGotop
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50
        if (top >= 0) {
          clearInterval(timeTop)
        }
      }, 10)
    },
    /* 获取点赞、分享、收藏、浏览量 */
    getamount () {
      getAmount(this.$route.query.id, this.$route.query.columnId, {p: this.$cookie.get('wlymobilephone')}).then((res) => {
        if (res.data.status === 200) {
          if (res.data.data.star !== undefined) {
            this.star = res.data.data.star
            // console.log('star:' + this.star)
          }
          if (res.data.data.isStar === 'true') this.starflag = true
          if (res.data.data.collect !== undefined) this.collect = res.data.data.collect
          if (res.data.data.isCollect === 'true') this.collectflag = true
          if (res.data.data.share !== undefined) this.share = res.data.data.share
          if (res.data.data.pv !== undefined) {
            this.pv = res.data.data.pv
          } else {
            this.pv = 0
          }
          /* 获取浏览量 */
          this.setamount('pv')
        }
      })
    },
    /* 设置浏览量、分享 */
    setamount (type) {
      let param = {
        'menuId': this.$route.query.columnId,
        'dataId': this.$route.query.id
      }
      if (type === 'share') param.share = 1
      if (type === 'pv') param.pv = 1
      setAmount(JSON.stringify(param)).then((res) => {
        if (res.data.status === 200) {
          if (type === 'share') this.share = this.share + 1
          if (type === 'pv') {
            this.pv = this.pv + 1
            this.$emit('pvcount', this.pv)
          }
        }
      })
    }
  }
}
</script>

<style>
.quantitywidget {
  position: fixed;
  width: 44px;
  left: 50%;
  margin-left: 620px;
  z-index: 1;
  top: 24%;
  text-align: center;
}
.quantitywidget li {
  display: inline-block;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.04);
  cursor: pointer;
  margin: 0 0 6px 0;
  transition: all 0.3s;
  position: relative;
}
.quantitywidget li span {
  display: block;
  position: absolute;
  height: 14px;
  line-height: 14px;
  border-radius: 6px;
  padding: 0 4px;
  background: #b2bac2;
  color: #fff;
  left: 30px;
  top: -2px;
  font-size: 12px;
}
.quantitywidget li i {
  display: block;
  margin: 6px auto;
}
.quantitywidget li.nostyle {
  background: none;
  box-shadow: none;
  border-radius: 0;
  height: auto;
  color: #c6c6c6;
  font-size: 12px;
}
.quantitywidget li.star .icon-zan2{
  background-position: -64px 0;
}
.quantitywidget li.star span{
  background: #0da78f;
  color: #fff;
}
.quantitywidget li.collect .icon-collect2{
  background-position: -128px -64px;
}
.quantitywidget li.collect span{
  background: #ffc347;
  color: #fff;
}
.social-share .social-share-icon{
  width: 44px;
  height: 44px;
  line-height: 44px;
  background: #fff;
  border: none;
  box-shadow: 0 2px 4px 0 rgba(0,0,0,.04);
  color: #b2bac2;
}
.social-share .icon-qq:hover,
.social-share .icon-wechat:hover,
.social-share .icon-weibo:hover{
  background: #fff;
  transition: all 0.3s;
}
.social-share .icon-qq:hover{
  color: #55b2f1;
}
.social-share .icon-wechat:hover{
  color: #44b035;
}
.social-share .icon-weibo:hover{
  color: #d52b2a;
}
@media only screen and (max-width: 1440px){
  .quantitywidget{
    margin-left: 608px;
    top: 16%;
  }
  .quantitywidget li,
  .social-share .social-share-icon{
    width: 40px;
    height: 40px;
    line-height: 40px;
  }
  .quantitywidget li i{
    margin: 4px auto 0;
  }
  .quantitywidget li span{
    left: 26px;
  }
  .social-share .icon-wechat .wechat-qrcode{
    top: -154px;
    right: 48px;
    left: auto;
    box-shadow: 0 0px 20px #ddd;
  }
  .social-share .icon-wechat .wechat-qrcode:after{
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/rightsidebar/index.vue